module.exports = {
      id: "interval-hr-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#interval-hr-usage",
      toString: function () {
        return this.url;
      }
    }